export default __webpack_public_path__ + "static/media/tm.e24edafc.svg";